// extracted by mini-css-extract-plugin
module.exports = {"root":"Tooltip_root__2Ou1N","container":"Tooltip_container__CfS-_","tip":"Tooltip_tip__H4kYs"};